import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight, faCheck} from '@fortawesome/free-solid-svg-icons'
import logoImage from '../img/consultMidiaLogo.png';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {useHistory} from "react-router-dom";
import React, {useEffect} from 'react';

import api from '../services/api';
import FacebookPixel from "../capturePixel/Facebook";

export function FifthQuestion() {
    const history = useHistory();

    useEffect(() => {
        // @ts-ignore
        document.getElementById("iconCheckA").style.display = 'none';
        // @ts-ignore
        document.getElementById("iconCheckB").style.display = 'none';
        // @ts-ignore
        document.getElementById("iconCheckC").style.display = 'none';
        // @ts-ignore
        document.getElementById("iconCheckD").style.display = 'none';
    }, []);

    const name = sessionStorage.getItem('name');
    const email = sessionStorage.getItem('email');
    const phoneNumber = sessionStorage.getItem('phoneNumber');
    const nameCompany = sessionStorage.getItem('nameCompany');
    const utm_source = sessionStorage.getItem('utm_source');
    const utm_campaign = sessionStorage.getItem('utm_campaign');
    const utm_content = sessionStorage.getItem('utm_content');
    const utm_term = sessionStorage.getItem('utm_term');

    let sizeCompany: HTMLInputElement | null;

    const MySwal = withReactContent(Swal);

    window.addEventListener("keypress", (event) => {
        let buttonA = document.getElementById("buttonA") as HTMLInputElement;
        let buttonB = document.getElementById("buttonB") as HTMLInputElement;
        let buttonC = document.getElementById("buttonC") as HTMLInputElement;
        let buttonD = document.getElementById("buttonD") as HTMLInputElement;
        let iconCheckA = document.getElementById("iconCheckA");
        let iconCheckB = document.getElementById("iconCheckB");
        let iconCheckC = document.getElementById("iconCheckC");
        let iconCheckD = document.getElementById("iconCheckD");

        if (event.key === "a") {
            event.preventDefault()
            buttonA.click();

        } else if (event.key === "b") {
            event.preventDefault()
            buttonB.click();
            if (iconCheckA?.style.display)
                iconCheckA.style.display = 'none';
            if (iconCheckB?.style.display)
                iconCheckB.style.display = 'block';
            if (iconCheckC?.style.display)
                iconCheckC.style.display = 'none';
            if (iconCheckD?.style.display)
                iconCheckD.style.display = 'none';
        } else if (event.key === "c") {
            event.preventDefault()
            buttonC.click();
            if (iconCheckA?.style.display)
                iconCheckA.style.display = 'none';
            if (iconCheckB?.style.display)
                iconCheckB.style.display = 'none';
            if (iconCheckC?.style.display)
                iconCheckC.style.display = 'block';
            if (iconCheckD?.style.display)
                iconCheckD.style.display = 'none';
        } else if (event.key === "d") {
            event.preventDefault()
            buttonD.click();
            if (iconCheckA?.style.display)
                iconCheckA.style.display = 'none';
            if (iconCheckB?.style.display)
                iconCheckB.style.display = 'none';
            if (iconCheckC?.style.display)
                iconCheckC.style.display = 'none';
            if (iconCheckD?.style.display)
                iconCheckD.style.display = 'block';
        }
    });

    async function handleQuestion(e: any) {
        let fontIcon = document.getElementById("fontIcon");
        let btnHandle = document.querySelector("#lastButton") as HTMLButtonElement;

        fontIcon!.style.display = 'none';
        btnHandle.disabled = true;
        e.preventDefault();

        const data = {
            "name": name,
            "email": email,
            "phoneNumber": phoneNumber,
            "companyName": nameCompany,
            "companySize": sizeCompany?.value,
            "utm_source": utm_source,
            "utm_campaign": utm_campaign,
            "utm_content": utm_content,
            "utm_term": utm_term,
        }

        try {
            const response = await api.post('import/exact.php', data);

            console.log("#### response: ", response);

            await MySwal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: "Enviado com sucesso!",
                position: 'top',
                showConfirmButton: false,
                timer: 1500,

            })

            history.push('/thankscreen');

        } catch (err) {
            await MySwal.fire({
                icon: 'error',
                title: 'Falhou',
                text: "Tente novamente mais tarde",
                position: 'center'
            })

            fontIcon!.style.display = 'block';
            btnHandle.disabled = false;

            console.log("#### error: ", err);
        }
    }

    function handleRadio() {
        let buttonA = document.getElementById("buttonA") as HTMLInputElement;
        let buttonB = document.getElementById("buttonB") as HTMLInputElement;
        let buttonC = document.getElementById("buttonC") as HTMLInputElement;
        let buttonD = document.getElementById("buttonD") as HTMLInputElement;
        let iconCheckA = document.getElementById("iconCheckA");
        let iconCheckB = document.getElementById("iconCheckB");
        let iconCheckC = document.getElementById("iconCheckC");
        let iconCheckD = document.getElementById("iconCheckD");

        if (buttonA.checked) {
            sizeCompany = document.getElementById("buttonA") as HTMLInputElement;
            if (iconCheckA?.style.display)
                iconCheckA.style.display = 'block';
            if (iconCheckB?.style.display)
                iconCheckB.style.display = 'none';
            if (iconCheckC?.style.display)
                iconCheckC.style.display = 'none';
            if (iconCheckD?.style.display)
                iconCheckD.style.display = 'none';
        }

        if (buttonB.checked) {
            sizeCompany = document.getElementById("buttonB") as HTMLInputElement;
            if (iconCheckA?.style.display)
                iconCheckA.style.display = 'none';
            if (iconCheckB?.style.display)
                iconCheckB.style.display = 'block';
            if (iconCheckC?.style.display)
                iconCheckC.style.display = 'none';
            if (iconCheckD?.style.display)
                iconCheckD.style.display = 'none';
        }

        if (buttonC.checked) {
            sizeCompany = document.getElementById("buttonC") as HTMLInputElement;
            if (iconCheckA?.style.display)
                iconCheckA.style.display = 'none';
            if (iconCheckB?.style.display)
                iconCheckB.style.display = 'none';
            if (iconCheckC?.style.display)
                iconCheckC.style.display = 'block';
            if (iconCheckD?.style.display)
                iconCheckD.style.display = 'none';
        }

        if (buttonD.checked) {
            sizeCompany = document.getElementById("buttonD") as HTMLInputElement;
            if (iconCheckA?.style.display)
                iconCheckA.style.display = 'none';
            if (iconCheckB?.style.display)
                iconCheckB.style.display = 'none';
            if (iconCheckC?.style.display)
                iconCheckC.style.display = 'none';
            if (iconCheckD?.style.display)
                iconCheckD.style.display = 'block';
        }
    }

    return (
        <>
            <FacebookPixel nameTracking="Fifth"/>
            <div className="progress">
                <div className="progress-bar progress-bar-100" role="progressbar"/>
            </div>
            <div className="container">
                <div className=" d-block d-md-none">
                    <img className="img-fluid image" src={logoImage} alt="logo"/>
                </div>
                <section className="container-body-last">
                    <div className="row d-flex flex-column align-content-lg-start">
                        <div className="col-md-2">
                            <span>5<FontAwesomeIcon icon={faArrowRight}/></span>
                        </div>
                        <div className="col-md-6 d-flex flex-column align-content-lg-start ">
                            <div>
                                <span className="span">Finalmente, nos diga, qual o tamanho desta organização?</span>
                            </div>
                            <div className="checkOption">
                                <div>
                                    <label className="labelOption ">
                                        <div className="letterOption mr-2 float-left ">
                                            <span>A</span>
                                        </div>
                                        <input onClick={handleRadio} id="buttonA" className="inputOption"
                                               value="Micro Empresa"
                                               type="radio"
                                               name="sizeCompany"/>
                                        <div id="iconCheckA" className="checkIcon">
                                            <FontAwesomeIcon icon={faCheck}/>
                                        </div>
                                        Micro Empresa (faturamento anual até R$350.000)

                                    </label>
                                </div>
                            </div>
                            <div className="checkOption">
                                <div>
                                    <label className="labelOption">
                                        <div className="letterOption mr-2 float-left mt-3 mb-3">
                                            <span>B</span>
                                        </div>
                                        <input onClick={handleRadio} id="buttonB" className="inputOption"
                                               value="Pequena Empresa" type="radio"
                                               name="sizeCompany"/>
                                        <div id="iconCheckB" className="checkIcon">
                                            <FontAwesomeIcon icon={faCheck}/>
                                        </div>
                                        Pequena Empresa (faturamento anual de R$350.000 a R$5 Milhões)

                                    </label>
                                </div>
                            </div>
                            <div className="checkOption">
                                <div>
                                    <label className="labelOption">
                                        <div className="letterOption mr-2 float-left mt-3 mb-3">
                                            <span>C</span>
                                        </div>
                                        <input onClick={handleRadio} id="buttonC" className="inputOption"
                                               value="Média Empresa"
                                               type="radio"
                                               name="sizeCompany"/>
                                        <div id="iconCheckC" className="checkIcon">
                                            <FontAwesomeIcon icon={faCheck}/>
                                        </div>
                                        Média Empresa (faturamento anual de R$5 Milhões a R$20 Milhões)

                                    </label>
                                </div>
                            </div>
                            <div className="checkOption">
                                <div>
                                    <label className="labelOption">
                                        <div className="letterOption mr-2 float-left mt-3 mb-3">
                                            <span>D</span>
                                        </div>
                                        <input onClick={handleRadio} id="buttonD" className="inputOption"
                                               value="Grande Empresa" type="radio"
                                               name="sizeCompany"/>
                                        <div id="iconCheckD" className="checkIcon">
                                            <FontAwesomeIcon icon={faCheck}/>
                                        </div>
                                        Grande Empresa (faturamento anual acima de R$20 Milhões)

                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="row next">
                        <div className="col-sm-2">
                            <button id="lastButton" onClick={handleQuestion}>Enviar<FontAwesomeIcon id='fontIcon' icon={faCheck}/>
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}